import { AuthFlowType, B2BProducts } from "@stytch/vanilla-js/b2b";
import type { Environment } from "~/types/domain";
import { get_full_app_url } from "~/lib/domain";

export function get_stytch_config(environment: Environment) {
  const authenticate_url = get_full_app_url("/authenticate", environment);
  const reset_password_url = get_full_app_url("/reset-password", environment);

  return {
    authFlowType: AuthFlowType.Discovery,
    products: [
      B2BProducts.emailMagicLinks,
      B2BProducts.oauth,
      B2BProducts.passwords,
    ],
    emailMagicLinksOptions: {
      loginRedirectURL: authenticate_url,
      signupRedirectURL: authenticate_url,
      discoveryRedirectURL: authenticate_url,
    },
    oauthOptions: {
      providers: [
        {
          type: "google" as const,
          providerParams: {
            prompt: "select_account",
            access_type: "offline",
            include_granted_scopes: "true",
          },
        },
        { type: "microsoft" as const },
      ],
      loginRedirectURL: authenticate_url,
      signupRedirectURL: authenticate_url,
      discoveryRedirectURL: authenticate_url,
    },
    passwordOptions: {
      loginRedirectURL: authenticate_url,
      resetPasswordRedirectURL: reset_password_url,
      resetPasswordExpirationMinutes: 60,
    },
    sessionOptions: {
      sessionDurationMinutes: 1440,
    },
  };
}

export const stytch_styles = {
  fontFamily: "Inter, sans-serif",
  hideHeaderText: true,
  container: {
    width: "100%",
    backgroundColor: "#ffffff",
    borderColor: "#e0e0e0",
    borderRadius: "8px",
  },
  colors: {
    primary: "#000000",
    secondary: "#666666",
    success: "#4ade80",
    error: "#f87171",
  },
  buttons: {
    primary: {
      backgroundColor: "#00a6a6",
      textColor: "#ffffff",
      borderColor: "#00a6a6",
      borderRadius: "8px",
    },
    secondary: {
      backgroundColor: "#ffffff",
      textColor: "#000000",
      borderColor: "#e0e0e0",
      borderRadius: "8px",
    },
  },
  inputs: {
    borderColor: "#e0e0e0",
    borderRadius: "8px",
    textColor: "#000000",
    placeholderColor: "#666666",
    backgroundColor: "#ffffff",
  },
};
